// extracted by mini-css-extract-plugin
export default {"form":"ChangeProductForm_form__GW8g6","select":"ChangeProductForm_select__oPT0r","label":"ChangeProductForm_label__iy73X"};